<template>
    <div>
        <h1 class="title is-4">{{ t["title.signup"] }}</h1>
        <h2 class="subtitle is-5 mb-5">{{ t["subtitle.signup"] }}</h2>
        <div class="mb-3">
            <b-radio v-model="type" name="type" native-value="type0" @input="changed()">
                Ich habe die Kategorie A1 mit 45km/h oder noch keinen Kurs besucht und möchte A (35kW) oder A1.
            </b-radio>
        </div>
        <div class="mb-3">
            <b-radio v-model="type" name="type" native-value="type1" @input="changed()">
                Ich habe bereits die Kategorie A1 <b>OHNE GESCHWINDIGKEITS-BESCHRÄNKUNG</b> und möchte den Kurs für A (35kW) absolvieren.
            </b-radio>
        </div>
        <div class="columns is-multiline mt-3" v-if="type">
            <div class="column is-full">
                <h1 class="title is-4">{{ t["title.change"] }}</h1>
            </div>
            <div class="column is-half" v-if="type == 'type0'">
                <b-field :label="t['part1']">
                    <b-select v-model="courseIndex[0]" @input="changed()" :class="true ? 'is-danger' : ''" expanded>
                        <option :value="null">
                            {{ t["noselection"] }}
                        </option>
                        <option v-for="(c, i) in courses[0]" :value="i" :key="i" :disabled="!c.isAvailable || !isAvailable(0, c)">
                            {{ date(c.isoDate) }} {{ c.isAvailable ? `(Freie Plätze: ${Math.max(c.freeplaces, 0)})` : " (ausgebucht)" }}
                        </option>
                    </b-select>
                </b-field>
            </div>
            <div class="column is-half" v-if="type == 'type0'">
                <b-field :label="t['part2']">
                    <b-select v-model="courseIndex[1]" @input="changed()" expanded>
                        <option :value="null">
                            {{ t["noselection"] }}
                        </option>
                        <option v-for="(c, i) in courses[1]" :value="i" :key="i" :disabled="!c.isAvailable || !isAvailable(1, c)">
                            {{ date(c.isoDate) }} {{ c.isAvailable ? `(Freie Plätze: ${Math.max(c.freeplaces, 0)})` : " (ausgebucht)" }}
                        </option>
                    </b-select>
                </b-field>
            </div>
            <div class="column is-half" v-if="type == 'type0' || type == 'type1'">
                <b-field :label="t['part3']">
                    <b-select v-model="courseIndex[3]" @input="changed()" expanded>
                        <option :value="null">
                            {{ t["noselection"] }}
                        </option>
                        <option v-for="(c, i) in courses[3]" :value="i" :key="i" :disabled="!c.isAvailable || !isAvailable(3, c)">
                            {{ date(c.isoDate) }} {{ c.isAvailable ? `(Freie Plätze: ${Math.max(c.freeplaces, 0)})` : " (ausgebucht)" }}
                        </option>
                    </b-select>
                </b-field>
            </div>
        </div>
    </div>
</template>

<script>
import Resources from "./Resources";
import moment from "moment";
import WidgetUI from "../WidgetUI";

export default {
    props: ["data", "languageId", "form"],
    data: () => ({
        courses: null,
        courseIndex: [null, null, null, null],
        courseDate: [null, null, null, null],
        coursesValid: false,
        type: "type0",
        t: {},
        e: {},
    }),
    mixins: [WidgetUI],
    created() {
        this.t = Resources[this.languageId == "en" ? "en" : "de"];
    },
    mounted() {
        this.initData();
    },
    methods: {
        moment,
        date(d) {
            const from = moment(d);
            const to = moment(from).add(4, "hours");

            return from.format("DD.MM.YYYY HH:mm") + " - " + to.format("HH:mm");
        },
        initData() {
            this.courses = [[], [], [], []]

            for (let g of this.data) {
                for (let c of g.courses) {
                    switch (c.name) {
                        case "PGS Teil 1":
                            this.courses[0].push(c);
                            break;
                        case "PGS Teil 2":
                            this.courses[1].push(c);
                            break;
                        case "PGS Teil 2a":
                            this.courses[2].push(c);
                            break;
                        case "PGS Teil 3":
                            this.courses[3].push(c);
                            break;
                    }
                }
                
            }
        },
        parseDate: course => course ? moment(course.isoDate) : null,
        changed() {
            this.$emit("selected");

            for (let i = 0; i < 4; i++) {
                this.courseDate[i] = this.parseDate(this.courses[i][this.courseIndex[i]]);

                if (this.type == "type0")
                    this.courseDate[2] = this.courseIndex[2] = null;
                else if (this.type === "type1")
                    this.courseDate[0] = this.courseDate[1] = this.courseDate[2] =
                    this.courseIndex[0] = this.courseIndex[1] = this.courseIndex[2] = null;
            }

            let date0 = this.courseDate[0];

            for (let i = 1; i < 4; i++) {
                const date1 = this.courseDate[i];

                if (date0 !== null && date1 !== null && date0.isSameOrAfter(date1)) {
                    this.courseDate[i] = null;
                    this.courseIndex[i] = null;
                }

                date0 = date1 || date0;
            }

            this.coursesValid = this.courses.every((c, i) => c && this.courseIndex[i] !== null);
            this.form.courseIds = [];

            for (let i = 0; i < 4; i++) {
                const index = this.courseIndex[i];

                if (index !== null) {
                    const course = this.courses[i][index];

                    this.form.courseIds.push(course.id);
                    this.courseDate[i] = this.parseDate(course);
                }
            }
        },
        isAvailable(index, course) {
            let date0 = this.courseDate[0];
            let date1 = this.parseDate(course);

            for (let i = 1; i < index; i++) {
                date0 = this.courseDate[i] || date0;
            }

            if (index > 0 && date0 && date0.isSameOrAfter(date1))
                return false;

            return true;
        }
    },
}
</script>